<nav aria-label="breadcrumb">
    <div class="breadcrumb-container">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a
                    href="javascript:void(0)"
                    (click)="onAllClick()"
                    class="allbreadcrumb1"
                    [ngClass]="{ 'text-green': breadcrumbs.length === 0 }"
                    [attr.id]="'go-move-breadcrumb-all'"
                    [attr.data-test]="'go-move-breadcrumb-all'"
                >
                    All
                </a>
            </li>
            <li *ngFor="let folder of breadcrumbs; let i = index" class="breadcrumb-item">
                <a
                    class="topic-title-text"
                    href="javascript:void(0)"
                    (click)="onBreadcrumbClick(i)"
                    [attr.title]="folder.folderName"
                    [ngClass]="{ 'text-green': i === breadcrumbs.length - 1 }"
                    [attr.id]="'go-move-breadcrumb-' + i"
                    [attr.data-test]="'go-move-breadcrumb-' + i"
                    >{{ folder.folderName }}</a
                >
            </li>
        </ol>
    </div>
</nav>
